import React from 'react'

export const UploadManagerContext = React.createContext({ updateFiles: () => {} })
export const FilesContext = React.createContext([])
